export default function CoinWhitepaper({ wp }) {
  return (
    <>
      {wp.vision && (
        <div className="grid grid-cols-12 gap-3 mb-3">
          <div className="col-span-12 md:col-span-6 border border-[#3a3a3a] bg-[#121212] p-6">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#cfff04] mb-2">// Vision</div>
            <p className="text-sm text-[#efefef] leading-relaxed">{wp.vision}</p>
          </div>
          <div className="col-span-12 md:col-span-6 border border-[#3a3a3a] bg-[#121212] p-6">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#cfff04] mb-2">// Utility</div>
            <p className="text-sm text-[#efefef] leading-relaxed">{wp.utility}</p>
          </div>
        </div>
      )}

      {wp.tokenomics && (
        <div className="border border-[#3a3a3a] bg-[#121212] p-6 mb-3">
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#cfff04] mb-3">// Tokenomics</div>
          <ul className="space-y-2">
            {wp.tokenomics.map((t) => (
              <li key={t} className="text-sm text-[#efefef] flex gap-3">
                <span className="text-[#cfff04] font-mono">▸</span>{t}
              </li>
            ))}
          </ul>
        </div>
      )}

      {wp.roadmap && (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
          {wp.roadmap.map((p) => (
            <div key={p.phase} className="border border-[#3a3a3a] bg-[#121212] p-5">
              <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-2">{p.phase}</div>
              <div className="font-display text-lg font-bold uppercase mb-3">{p.title}</div>
              <ul className="space-y-1.5">
                {(p.items || []).map((it) => (
                  <li key={it} className="text-xs text-[#e2e2e2] flex gap-2">
                    <span className="text-[#d0d0d0] font-mono">▸</span>{it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
